import { css } from "@emotion/react"
import { forwardRef } from "react"

type Props = {
  children: React.ReactNode
  underline?: boolean
  size?: "medium" | "small"
} & Pick<JSX.IntrinsicElements["a"], "href" | "target" | "download">

/**
 * Next.jsのLinkコンポーネントから使えるようにするためforwardRefを使用しています。
 * @see https://nextjs.org/docs/api-reference/next/link#if-the-child-is-a-functional-component
 */
const Link = forwardRef<HTMLAnchorElement, Props>(
  ({ underline = false, size, href, target, children, download }, ref) => {
    const textDecoration = underline ? "underline" : undefined
    const fontSize = size === "small" ? 12 : undefined

    return (
      <a
        ref={ref}
        href={href}
        target={target}
        download={download}
        css={styles.default}
        style={{ textDecoration, fontSize }}
      >
        {children}
      </a>
    )
  }
)

export default Link

const styles = {
  default: css`
    text-decoration: none;
    &[href] {
      color: #ed8804;
      &:hover {
        text-decoration: underline;
      }
    }
  `,
}
